export default {
  backendEndpoint: 'backendapi'
}